/*eslint-disable no-unused-vars */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

import { loadLanguageAsync } from '_shared/i18n'

import { routesAccount } from '_shared/account/routes'
import { account } from '_shared/account'

import store from '../store'
import EventBus from "_shared/EventBus";
import { hubs } from '../main'

import EventView from '../views/pages/EventView'
import WaitingRoomView from '../views/pages/WaitingRoomView_PreviewVideo'
import LiveContainerView from '../views/pages/LiveContainerView'

import VimeoFrame from '../components/IFrameServices/VimeoFrame'


Vue.use(VueRouter)


const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requireAuth: false },
    beforeEnter: async (to, from, next) => {
      // var items = await store.dispatch('getEventItems');
      // if (items.length == 1)
      //   next({name:'Event', params: { eventId: items[0].id } })      
      store.commit("SET_EventId", null);
      next()
    },
  },
  {
    path: '/:eventId',
    component: { render(c) { return c('router-view') } },
    meta: { requireAuth: false },
    children: [
      {
        path: '',
        name: 'Event',
        // redirect:'waitingroom',
        component: EventView,
        meta: { requireAuth: false }
      },
      {
        path: 'regasus',
        name: 'Regasus',
        meta: { requireAuth: false },
        beforeEnter: async (from, to, next) => {

          let response;
          try {
            response = await window.axios.post(`regasus?jwtToken=${from.query.jwt}`);
          } catch (e) {
            console.log(e.response)
            response = e.response;
          }

          if (response.status != 200) {
            next('/')
          }
          else {
            await window.account.initAsync()

            let eventId = store.state.event.event_id
            console.log(account.methods.hasEvent(eventId))
            if (eventId)
              router.replace({ name: 'Event', params: { eventId: eventId } });
          }
        }
      },
      {
        path: 'waitingroom',
        name: 'WaitingRoom',
        component: WaitingRoomView,
        meta: { requireAuth: false },
        beforeEnter: (to, from, next) => {
          if (store.getters['notification/roomState'] === 'live' || account.methods.hasRole('testuser'))
            router.push({ name: 'Live', params: { eventId: to.params.eventId } });
          else
            next();
        }
      },
      {
        path: 'live',
        name: 'Live',
        component: LiveContainerView,
        meta: { requireAuth: false },
        beforeEnter: (to, from, next) => {
          if (store.getters['notification/roomState'] === 'live' || account.methods.hasRole('testuser'))
            next();
          else
            router.push({ name: 'WaitingRoom', params: { eventId: to.params.eventId } })
        },
        children: [
          {
            path: 'stream',
            name: 'Stream',
            component: VimeoFrame,
            meta: { requireAuth: false },
          },
        ]
      }
    ]
  },

  ...routesAccount,
  {
    ///Default routes
    path: '*',
    meta: { requireAuth: false },
    redirect:'/'    
  },
]



const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})


router.afterEach(async () => {
  await loadLanguageAsync(store.getters['i18n/getCurrent'], store.state.client_id)
})

router.beforeEach(async (to, from, next) => {

  if (to.path == "account/callback" || to.path == "account/slilentrenew") { next(false); return; }

  if (to.matched.some(record => record.meta.requireAuth))
    if (store.getters['account/isLogIn'] == true) {

      await hubs.StartAll();

      if (to.name == "Event" || to.params.eventId != null)
        next(await GetEvent(to, from, next, true))
      else
        next()
    }
    else {
      var user = await store.dispatch('account/getUser');

      if (user == null) {
        next(false);
        window.account.login();
      }
      else
        next(to)
    }
  else {
    if (to.name == "Event" || to.params.eventId != null)
      next(await GetEvent(to, from, next, true))
    else
      next()
  }

  return;
})


async function GetEvent(to, from, next, isPublic) {
  let res = await window.axios.get(`api/event/ExistEvent?eventid=${to.params.eventId}&isActive=${true}`);


  if (res.data.exist == true && (account.methods.hasEvent(res.data.eventId) || isPublic)) {

    if (res.data.active == false)
      router.replace('/');
    else {
      store.commit('SET_EventId', res.data.eventId);
      //store.commit('notification/SET_EventStateItem', await window.notification.getEventItemState(res.data.eventId));    
      store.commit('notification/SET_EventStateItem', (await window.axios.get(`api/event/GetEventState?eventid=${res.data.eventId}`)).data);
    }
  }
  else {
    console.log("Event not allowed")

    window.location.replace((await window.axios.get('Authenticate/EventAppHome')).data.url)
    return false;
    //next(router.push('/'));
  }

}

export default router
